
import { store } from '../../state/redux';
import { queryClient  } from '../../state/queryClient';
import { axios_equipement_modify , axios_equipement_create } from "../../axios/axios_equipement";



export const handle_equipment = async(equipement, files,isnewequipement)=>{
    const lead = store.getState().lead.leadactu; 

    const datas = new FormData();
    datas.append("data", JSON.stringify(equipement));
    for (let i = 0; i < files.length; i++) {datas.append("files", files[i]);}

    isnewequipement ?  await axios_equipement_create(datas) : await axios_equipement_modify(datas)   ;

    // INVALIDATION DES EQUIPEMENTS ET FICHIERS
    queryClient.invalidateQueries({ queryKey: ['documents',lead.id]}) ;
    queryClient.invalidateQueries({ queryKey: ['equipement',lead.id]}) ;
}

export const listecategories = ['Assurance de Personne','Assurance IARD','Assurances Pro','Autre'] ;

export const listetypesprix = ['Mensuel','Trimestriel', 'Semestriel', 'Annuel'] ;


export const jsontypeequipement = {
    'Assurance de Personne':
        ['Santé', 'Prévoyance (Hospi, décès, scolaire)', 'Assurance de Prêt', 'Animaux', 'Protection juridique'],
    'Assurance IARD':
        ['Auto', ' Moto', 'Habitation', 'Propriétaire non occupant', 'Loyer impayés'],
    'Assurances Pro': ['Santé Madelin', 'Prévoyance Madelin', 'Retraite Madelin', 'Multirisque Pro', 'RC Pro', 'PJ', 'Protection fiscale', 'Flotte Auto', 'Flotte Cyclo'],
    'Autre': [' ']
}